export default "__VITE_ASSET__DcrHsRaQ__"